export enum Module {
  User = "UserModule",
  Panel = "Panel",
  Documents = "Documents",
  Discussion = "Discussion",
}
